import { PlayerScores } from './player-scores';

export class Players {
    name: string;
    playerScores: PlayerScores[];
}
